import { ETypeCoupon, ITopCoupons } from "../interfaces/top.coupons.state";
import Api from "@/api/index.ts";
import { factoryTopCoupons } from "@/services/factory/coupons";

const initTopCoupons: ITopCoupons = {
  all: {
    coupons: [],
    countCoupons: 0,
    nextCursor: 0
  },
  free: {
    coupons: [],
    countCoupons: 0,
    nextCursor: 0
  },
  newest: {
    coupons: [],
    countCoupons: 0,
    nextCursor: 0
  },
  best: {
    coupons: [],
    countCoupons: 0,
    nextCursor: 0
  },
  isLoading: false,
  isLoadingMerchant: false,
  currentType: ETypeCoupon.free,
  currentLang: ""
};

export default {
  namespaced: true,
  state: initTopCoupons,
  actions: {
    async setTopCoupons({ state, commit }, type: ETypeCoupon) {
      if (
        state.currentLang == Api.lang &&
        state[type] &&
        state[type].countCoupons
      ) {
        return Promise.resolve(state[type]);
      }
      if (Api.lang !== state.currentLang) {
        await commit("clearTopCoupons");
      }
      commit("setCurrentLang", Api.lang);
      commit("isLoadingMerchant");
      const { data } = await Api.getTopCoupons(type, 10, null);
      commit("isLoadingMerchant", false);
      const topCoupons = factoryTopCoupons(data, type);
      commit("setTopCoupons", {
        topCouponsItem: topCoupons,
        type: type
      });
      return Promise.resolve(data);
    },
    setType({ commit }, type) {
      commit("setType", type);
    },
    async loadMore({ state, commit }) {
      const type = state.currentType;
      const cursor = state[type].nextCursor;
      commit("isLoading");
      const { data } = await Api.getTopCoupons(type, 10, cursor);
      const couponsItem = factoryTopCoupons(data, type);
      commit("updateCoupon", {
        couponsItem: couponsItem,
        type: type
      });
      commit("isLoading", false);
      return Promise.resolve(data);
    }
  },
  mutations: {
    setTopCoupons(state: ITopCoupons, param) {
      state[param.type] = param.topCouponsItem;
      state.currentType = param.type;
    },
    setType(state: ITopCoupons, type) {
      state.currentType = type;
    },
    updateCoupon(state: ITopCoupons, param) {
      param.couponsItem.coupons.forEach(i => state[param.type].coupons.push(i));
      state[param.type].nextCursor = param.couponsItem.nextCursor;
    },
    isLoading(state: ITopCoupons, isLoading: boolean = true) {
      state.isLoading = isLoading;
    },
    isLoadingMerchant(state: ITopCoupons, isLoadingMerchant: boolean = true) {
      state.isLoadingMerchant = isLoadingMerchant;
    },
    setCurrentLang(state: ITopCoupons, lang) {
      state.currentLang = lang;
    },
    clearTopCoupons(state: ITopCoupons) {
      let types = ["all", "free", "newest", "best"];
      types.forEach(type => {
        state[type] = {
          coupons: [],
          countCoupons: 0,
          nextCursor: 0
        };
      });
    }
  },
  getters: {
    getCoupons: (state: ITopCoupons) => state[state.currentType],
    isLoading: (state: ITopCoupons) => state.isLoading,
    isLoadingMerchant: (state: ITopCoupons) => state.isLoadingMerchant
  }
};
